// extracted by mini-css-extract-plugin
module.exports = {"title":"Amount_title__1LDNX","numericValue":"Amount_numericValue__2HgF_","amount":"Amount_amount__17kMP","bold":"Amount_bold__3lUUJ"};